import React from 'react';
import { useLocation } from 'react-router-dom';

import DefaultLayout from '../../_layouts/default';

import List from './List';
import View from './View';
import Procedure1Representative from './Procedures/Procedure1/ChooseRepresentative';
import Procedure1Client from './Procedures/Procedure1/ChooseClient';
import Procedure1New from './Procedures/Procedure1/New';
import Procedure2 from './Procedures/Procedure2';

const Adversities: React.FC = () => {
  const { pathname } = useLocation();

  function getComponent(): React.ReactNode {
    if (pathname === '/projects/adversities') {
      return <List />;
    }
    if (pathname === '/projects/adversities/view') {
      return <View />;
    }
    if (pathname === '/projects/adversities/procedure1/representative') {
      return <Procedure1Representative />;
    }
    if (pathname === '/projects/adversities/procedure1/client') {
      return <Procedure1Client />;
    }
    if (pathname === '/projects/adversities/procedure1/new') {
      return <Procedure1New />;
    }
    if (pathname === '/projects/adversities/procedure2') {
      return <Procedure2 />;
    }

    return <List />;
  }

  return <DefaultLayout>{getComponent()}</DefaultLayout>;
};

export default Adversities;
